module.exports = __webpack_public_path__ + "media/backgrounds/diamond-array-fa330d2f.png";